



import { Eye, Download, X } from 'lucide-react';
import { allReduxClear } from '../../utils/utils';
import { useDispatch } from 'react-redux';


const BillPreviewModal = ({ isOpen, onClose, billData, reduxClear }) => {

    const dispatch = useDispatch()

    if (!isOpen) return null;
    console.log("billData-------", billData);

    const formatDate = (timestamp) => {
        return new Date(timestamp).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const onCloseModal = () => {
        onClose()
        if (reduxClear) {
            allReduxClear(dispatch);
        }
    }

    const generateBillNumber = () => `${Date.now().toString().slice(-4)}`;
    // const generateBillNumber = () => `${Date.now()}`;


    // Shared styles for both preview and PDF
    const getInvoiceStyles = () => `
        * { 
            margin: 0; 
            padding: 0; 
            box-sizing: border-box; 
        }
        
        body { 
            font-family: Arial, sans-serif; 
            line-height: 1.4; 
            color: #000; 
            padding: 20px; 
            background: white;
        }
        
        .invoice-container {
            max-width: 800px;
            margin: 0 auto;
            background: white;
            padding: 30px;
        }
        
        .invoice-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }
        
        .invoice-info {
            border: 1px solid #000;
            border-collapse: collapse;
        }
        
        .invoice-info td {
            padding: 8px 15px;
            border: 1px solid #000;
            font-size: 14px;
        }
        
        .invoice-info td:first-child {
            background-color: #e5e7eb;
            font-weight: 600;
            width: 140px;
        }
        
        .company-info {
            text-align: right;
        }
        
        .company-info h1 {
            color: #2563eb;
            font-size: 18px;
            margin-bottom: 10px;
            font-weight: bold;
        }

        .company-info h2 {
            font-size: 24px;
            margin-bottom: 5px;
            font-weight: bold;
        }
        
        .company-info p {
            font-size: 14px;
            margin: 2px 0;
        }
        
        .customer-info {
            text-align: right;
            margin-bottom: 20px;
            font-size: 14px;
        }
        
        .customer-info p {
            margin: 2px 0;
        }
        
        .services-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 30px;
        }
        
        .services-table th {
            background-color: #4b5563;
            color: white;
            padding: 10px;
            text-align: left;
            font-size: 14px;
            font-weight: 600;
        }
        
        .services-table td {
            padding: 10px;
            border-bottom: 1px solid #e5e7eb;
            font-size: 14px;
        }
        
        .services-table tr:nth-child(even) {
            background-color: #f9fafb;
        }
        
        .services-table .qty-col,
        .services-table .price-col,
        .services-table .discount-col,
        .services-table .total-col {
            text-align: center;
        }
        
        .bottom-section {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 30px;
        }
        
        .left-section {
            flex: 1;
            margin-right: 50px;
        }
        
        .payment-section {
            margin-bottom: 30px;
        }
        
        .payment-section h3 {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        
        .payment-section p {
            font-size: 14px;
            margin: 5px 0;
        }
        
        .notes-section h3 {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        
        .notes-section p {
            font-size: 14px;
        }
        
        .summary-section {
            flex-shrink: 0;
        }
        
        .summary-table {
            width: 350px;
        }
        
        .summary-row {
            display: flex;
            justify-content: space-between;
            padding: 8px 0;
            font-size: 14px;
        }
        
        .summary-row.with-border {
            border-bottom: 1px solid #e5e7eb;
        }
        
        .summary-row.total {
            font-weight: bold;
            font-size: 16px;
            border-bottom: 2px solid #000;
            border-top: 2px solid #000;
            margin: 10px 0;
            padding: 12px 0;
        }
        
        .summary-label {
            color: #3b82f6;
        }
        
        .discount-label {
            color: #dc2626;
        }
        
        .rupee-symbol {
            font-family: Arial, sans-serif;
        }
    `;

    // Direct PDF Download using html2canvas and jsPDF
    const handleDownloadPDF = async () => {
        try {
            // Dynamically import the libraries
            const html2canvas = (await import('html2canvas')).default;
            const jsPDF = (await import('jspdf')).default;

            const element = document.getElementById('bill-content');

            if (!element) {
                console.error('Bill content not found');
                return;
            }

            // Create canvas from the element
            const canvas = await html2canvas(element, {
                scale: 2, // Higher scale for better quality
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                width: element.scrollWidth,
                height: element.scrollHeight,
            });

            const imgData = canvas.toDataURL('image/png');

            // Calculate PDF dimensions
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 295; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;

            // Create PDF
            const pdf = new jsPDF('p', 'mm', 'a4');
            let position = 0;

            // Add first page
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            // Add additional pages if content is longer than one page
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            // Download the PDF
            const fileName = `Elevate-Salon-Invoice-${generateBillNumber()}.pdf`;
            pdf.save(fileName);

        } catch (error) {
            console.error('Error generating PDF:', error);
            // Fallback to the original print method if PDF generation fails
            handleFallbackPDF();
        }
    };

    // Fallback method (your original implementation)
    const handleFallbackPDF = () => {
        const printContent = document.getElementById('bill-content');

        if (!printContent) {
            console.error('Bill content not found');
            return;
        }

        const newWindow = window.open('', '_blank');

        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Elevate Salon - Invoice</title>
                <style>
                    ${getInvoiceStyles()}
                    
                    @media print {
                        body { 
                            margin: 0; 
                            padding: 10px; 
                        }
                        
                        .invoice-container {
                            border: 2px solid #000;
                            max-width: 100%;
                        }
                        
                        .services-table th {
                            background-color: #4b5563 !important;
                            color: white !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        
                        .services-table tr:nth-child(even) {
                            background-color: #f9fafb !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        
                        .invoice-info td:first-child {
                            background-color: #e5e7eb !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        
                        .summary-label {
                            color: #3b82f6 !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        
                        .discount-label {
                            color: #dc2626 !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                        
                        .company-info h1 {
                            color: #2563eb !important;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent.innerHTML}
            </body>
            </html>
        `;
        newWindow.document.write(htmlContent);
        newWindow.document.close();
        setTimeout(() => {
            newWindow.print();
        }, 500);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                {/* Modal Header */}
                <div className="flex justify-between items-center p-4 border-b bg-blue-50">
                    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                        <Eye className="w-5 h-5" />
                        Bill Preview
                    </h2>
                    <div className="flex gap-2">
                        <button
                            onClick={handleDownloadPDF}
                            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                        >
                            <Download className="w-4 h-4" />
                            Download PDF
                        </button>
                        <button
                            onClick={onCloseModal}
                            className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>
                {/* Bill Content */}
                <div className="flex-1 overflow-auto p-6 bg-gray-50">
                    {/* Add styles for preview */}
                    <style>{getInvoiceStyles()}</style>
                    <div className="invoice-container" id="bill-content">
                        {/* Invoice Header */}
                        <div className="invoice-header">
                            <table className="invoice-info">
                                <tbody>
                                    <tr>
                                        <td>Invoice ID :</td>
                                        <td>{generateBillNumber()}</td>
                                    </tr>
                                    <tr>
                                        <td>Payment Date :</td>
                                        <td>{formatDate(Date.now())}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="company-info">
                                <h1>TAX INVOICE</h1>
                                <h2>Elevate Salon</h2>
                                <p>3rd floor, Plot 16, Pocket 3, Sector 11, Dwarka,</p>
                                <p>7042026338</p>
                            </div>
                        </div>
                        {/* Customer Info */}
                        <div className="customer-info">
                            <p><strong>Name :</strong> {billData?.clientInfo?.name || 'Walk-in Customer'}</p>
                            {billData?.clientInfo?.phoneNumber && (
                                <p><strong>Contact :</strong> {billData?.clientInfo?.phoneNumber}</p>
                            )}
                        </div>

                        {/* Services Table */}
                        {billData?.serviceInfo?.length > 0 && (
                            <table className="services-table">
                                <thead>
                                    <tr>
                                        <th>Service</th>
                                        <th>Staff</th>
                                        <th className="qty-col">Qty</th>
                                        <th className="price-col">Price</th>
                                        <th className="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billData?.serviceInfo?.map((service, index) => (
                                        <tr key={index}>
                                            <td>{service?.serviceData?.name}</td>
                                            <td>{service?.staffData?.name || '-'}</td>
                                            <td className="qty-col">{service?.quantity || 1}</td>
                                            <td className="price-col">{parseFloat(service?.price || 0).toFixed(2)}</td>
                                            <td className="total-col">{parseFloat(service?.total || 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {/* Products Table */}
                        {billData?.products?.length > 0 && (
                            <table className="services-table">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Staff</th>
                                        <th className="qty-col">Qty</th>
                                        <th className="price-col">Price</th>
                                        <th className="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billData.products.map((product, index) => (
                                        <tr key={index}>
                                            <td>{product?.product?.productName}</td>
                                            <td>{product?.staffData?.name || '-'}</td>
                                            <td className="qty-col">{product?.quantity}</td>
                                            <td className="price-col">{parseFloat(product?.price || 0).toFixed(2)}</td>
                                            <td className="total-col">{parseFloat(product?.total || 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {/* Memberships Table */}
                        {billData?.memberShip?.length > 0 && (
                            <table className="services-table">
                                <thead>
                                    <tr>
                                        <th>Membership</th>
                                        <th>Staff</th>
                                        <th className="qty-col">Qty</th>
                                        <th className="price-col">Price</th>
                                        <th className="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billData.memberShip.map((membership, index) => (
                                        <tr key={index}>
                                            <td>{membership?.membership?.membershipName}</td>
                                            <td>{membership?.staffData?.name || '-'}</td>
                                            <td className="qty-col">1</td>
                                            <td className="price-col">{parseFloat(membership?.price || 0).toFixed(2)}</td>
                                            <td className="total-col">{parseFloat(membership?.total || 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {/* Packages Table */}
                        {billData?.package?.length > 0 && (
                            <table className="services-table">
                                <thead>
                                    <tr>
                                        <th>Package</th>
                                        <th className="qty-col">Qty</th>
                                        <th className="price-col">Price</th>
                                        <th className="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {billData.package.map((pkg, index) => (
                                        <tr key={index}>
                                            <td>{pkg?.package?.packageName}</td>
                                            <td className="qty-col">1</td>
                                            <td className="price-col">{parseFloat(pkg?.price || 0).toFixed(2)}</td>
                                            <td className="total-col">{parseFloat(pkg?.total || 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {/* Bottom Section - Two columns */}
                        <div className="bottom-section">
                            {/* Left Column - Payment Mode and Notes */}
                            <div className="left-section">
                                {/* Payment Mode Section */}
                                <div className="payment-section">
                                    <h3>Payment Mode</h3>
                                    {billData?.paymentMethod?.filter(pm => pm.price > 0).map((pm, index) => (
                                        <p key={index}>{pm.title}  ₹{parseFloat(pm.price || 0).toFixed(2)} </p>
                                    ))}
                                </div>
                                {/* Notes Section */}
                                <div className="notes-section">
                                    <h3>Notes:</h3>
                                    <p>{billData?.notes || 'Thank you for visiting Elevate Salon!'}</p>
                                </div>
                            </div>

                            {/* Right Column - Summary Section */}
                            <div className="summary-section">
                                <div className="summary-table">
                                    <div className="summary-row">
                                        <span className="summary-label">Subtotal</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.subTotal || 0).toFixed(2)}</span>
                                    </div>
                                    <div className="summary-row">
                                        <span className="summary-label">Actual Price</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.subTotal || 0).toFixed(2)}</span>
                                    </div>
                                    {billData?.billSummary?.discount > 0 && (
                                        <div className="summary-row">
                                            <span className="discount-label">
                                                Discount{billData.billSummary.discountType === 'percentage' ? `(${billData.billSummary.discountValue}%)` : ''}
                                            </span>
                                            <span className="discount-label">-<span className="rupee-symbol">₹</span> {parseFloat(billData.billSummary.discount).toFixed(2)}</span>
                                        </div>
                                    )}
                                    {billData?.billSummary?.taxableAmount > 0 && (
                                        <div className="summary-row">
                                            <span className="summary-label">Taxable Amount</span>
                                            <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.taxableAmount || 0).toFixed(2)}</span>
                                        </div>
                                    )}
                                    {billData?.billSummary?.extraCharges > 0 && (
                                        <div className="summary-row">
                                            <span className="summary-label">Extra Charge</span>
                                            <span>+<span className="rupee-symbol">₹</span> {parseFloat(billData.billSummary.extraCharges).toFixed(2)}</span>
                                        </div>
                                    )}
                                    {billData?.billSummary?.GST > 0 && (
                                        <div className="summary-row ">
                                            <span className="summary-label">GST {billData?.billSummary?.gstPercentage || 18}.00 %</span>
                                            <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.GST || 0).toFixed(2)}</span>
                                        </div>
                                    )}
                                    {billData?.billSummary?.balanceAmount ? <div className="summary-row">
                                        <span className="summary-label">Balance Amount</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.balanceAmount || 0).toFixed(2)}</span>
                                    </div> : ""}
                                    <div className="summary-row total">
                                        <span className="summary-label">Total</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.grandTotal || 0).toFixed(2)}</span>
                                    </div>
                                    <div className="summary-row">
                                        <span className="summary-label">Paid</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.payingNow || 0).toFixed(2)}</span>
                                    </div>
                                    {billData?.billSummary?.duePayment ? <div className="summary-row">
                                        <span className="summary-label">Due</span>
                                        <span><span className="rupee-symbol">₹</span> {parseFloat(billData?.billSummary?.duePayment || 0).toFixed(2)}</span>
                                    </div> : ""}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillPreviewModal;